export const deleteCurrentProductsGroupProduct = `mutation ($id_product_physical_group: Int!, $id_product_physical: Int!) {
    item: delete_prodigio_product_physical_groups_products_physical(where: {id_product_physical_group: {_eq: $id_product_physical_group}, id_product_physical: {_eq: $id_product_physical}}) {
      returning {
        id_product_physical
      }
    }
  }
  `;
